import useSWR from "swr";
import { DesignPreferencesResponse } from "../../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import { useAuthToken } from "hooks/useAuthToken";
import { getDesignPreferences } from "services/prospect";

const useDesignPreferences = (
  shouldFetch: boolean,
  prospectId: string
): {
  designPreferencesData: DesignPreferencesResponse | undefined;
  designPreferencesError: Error | undefined;
  designPreferencesLoading: boolean;
  refetch: () => Promise<DesignPreferencesResponse | undefined>;
} => {
  const authKey = useAuthToken("HYBRID")?.token ?? "";
  const proposalToken = useAuthToken("PROPOSAL")?.token;
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    shouldFetch && prospectId && [`Get Design Preferences`, prospectId],
    () =>
      getDesignPreferences({
        authKey: authKey || proposalToken || "",
        prospectId,
      })
  );
  return {
    designPreferencesData: data,
    designPreferencesError: error,
    designPreferencesLoading: isLoading || isValidating,
    refetch: mutate,
  };
};

export { useDesignPreferences };
